import React, { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import styled from "styled-components";

import { Dropdown, Menu, Pagination, Spin, Table } from "antd";

import { handleError } from "../../modules/presence/sagas";
import { roles } from "../../configs/constants";
import { AddTeamModal } from "./AddTeam.modal";
import { RemoveTeamModal } from "./RemoveTeam.modal";
import { AddUserModal } from "./AddUser.modal";
import { RemoveUserModal } from "./RemoveUser.modal";
import { DeleteVersion } from "./DeleteVersion";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;
`;

const baseapi = process.env.REACT_APP_API + "/api";
const PAGE_SIZE = 10;

const MobileAppVersions = ({ token, clients }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  const fetchAppVersions = async () => {
    setIsLoading(true);
    try {
      const result = await axios.post(
        `${baseapi}/mobile_app`,
        {
          sort: { release_date: -1 },
          page,
          pageSize: PAGE_SIZE
        },
        {
          headers: {
            Authorization: token
          }
        }
      );
      setData(result.data.docs);

      setTotal(result.data.total);
    } catch (e) {
      handleError(e);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchAppVersions();
  }, [page]);
  const columns = [
    {
      title: "code",
      dataIndex: "code",
      key: "code",
      render: code => {
        return <span>{code}</span>;
      }
    },
    {
      title: "Date de sortie",
      dataIndex: "release_date",
      key: "release_date",
      render: (date, record) => {
        return <span> {`${record.deleted ? "VERSION SUPPRIMEE " : dayjs(date).format("DD-MM-YYYY HH:mm:ss")}`}</span>;
      }
    },

    {
      title: "Notes",
      dataIndex: "release_note",
      key: "release_note"
    },
    {
      title: "Equipes/utilisateurs cibles",
      dataIndex: "users",
      key: "users",
      render: users => {
        if (users.length === 0) return <span>Tous les utilisateurs</span>;
        const clients = [];
        users
          .filter(user => user.role_id === roles.TERRAIN || user.role_id === roles.MANAGER)
          .forEach(user => {
            const curClientLabels = user.clientLabels || [];
            curClientLabels.forEach(label => {
              if (clients.indexOf(label) === -1) {
                clients.push(label);
              }
            });
          });
        if (clients.length === 0) return <span>Réservée aux admins</span>;
        return (
          <Dropdown
            overlay={
              <Menu>
                {users.map(user => (
                  <Menu.Item key={user.email}>{user.email}</Menu.Item>
                ))}
              </Menu>
            }
          >
            <span className="ant-dropdown-link"> {`${clients.join(", ")} (${users.length} utilisateur(s))`}</span>
          </Dropdown>
        );
      }
    },
    {
      title: "formio (pour Ecosystem)",
      dataIndex: "isFormio",
      key: "isFormio",
      render: isFormio => {
        return <span>{isFormio ? "oui" : "non"}</span>;
      }
    },
    {
      title: "lien",
      dataIndex: "link",
      key: "link",
      render: (link, record) => {
        return <span>{record.deleted ? "VERSION SUPPRIMEE" : link}</span>;
      }
    },
    {
      title: "num_code",
      dataIndex: "num_code",
      key: "num_code"
    },
    {
      title: "actions",
      dataIndex: "_id",
      key: "_id",
      render: (_id, record) => {
        return (
          <div>
            {!record.deleted && (
              <div>
                <AddTeamModal version_id={_id} token={token} clients={clients} onUpdate={fetchAppVersions} />
                <RemoveTeamModal
                  version_id={_id}
                  token={token}
                  clientsInVersion={record.clients || []}
                  onUpdate={fetchAppVersions}
                />
                <AddUserModal version_id={_id} token={token} onUpdate={fetchAppVersions} />
                <RemoveUserModal
                  version_id={_id}
                  token={token}
                  usersInVersion={record.users || []}
                  onUpdate={fetchAppVersions}
                />
              </div>
            )}
            <DeleteVersion version_id={_id} token={token} onUpdate={fetchAppVersions} isDeleted={record.deleted} />
          </div>
        );
      }
    }
  ];
  return (
    <Container>
      <HeaderContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          <div style={{ fontSize: 30, width: "30%" }}>{`Liste des versions mobiles`}</div>
        </div>
        <div style={{ width: "30%" }} />
      </HeaderContainer>
      <React.Fragment>
        {isLoading ? (
          <Spin />
        ) : (
          <Table rowKey="_id" columns={columns} dataSource={data} pagination={false} align="center" />
        )}
        <Pagination defaultCurrent={1} total={total} onChange={setPage} />
      </React.Fragment>
    </Container>
  );
};

export default MobileAppVersions;



// WEBPACK FOOTER //
// src/pages/mobileAppVersions/MobileAppVersions.js